import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, Button, Typography } from '@mui/material';

export interface ErrorStateProps {
  /** Short headline. */
  title?: string;
  /** Supporting description. */
  message?: string;
  /** When provided, renders a retry button. */
  onRetry?: () => void;
  /** Label for the retry button. */
  retryLabel?: string;
}

/** Generic error state used across pages and data containers. */
export function ErrorState({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
  retryLabel = 'Try again',
}: ErrorStateProps) {
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        py: 6,
        px: 3,
        minHeight: 240,
      }}
    >
      <ErrorOutlineRoundedIcon sx={{ fontSize: 48, color: 'error.main' }} />
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {message}
      </Typography>
      {onRetry ? (
        <Button variant="outlined" color="error" onClick={onRetry} sx={{ mt: 1 }}>
          {retryLabel}
        </Button>
      ) : null}
    </Box>
  );
}
